import { ProductServices } from '@/services/productServices';
import { getDraftInvoiceReady } from '@/utils/draftOrderPayValidation';
export default {
    namespaced: true,

    actions:{

        async getProductDataAction (){
            let res = await ProductServices.getProductAPI();
            let data = res.data;
            return data;
        }, 

        async getAddonProductDataAction (){
            let res = await ProductServices.getAddonProductAPI();
            let data = res.data;
            return data;
        }, 

        async saveDraftOrderAction(_, payload) {
            const requestPayload = {
                ...payload,
                invoice_ready: getDraftInvoiceReady({
                    order_title: payload?.order_title,
                    order_type: payload?.order_type,
                    links: payload?.links,
                }),
            };
            let res = await ProductServices.addDraftOrderAPI(requestPayload);
            let data = res.data;
            return data;
        },

        async getCountriesDataAction (){
            let res = await ProductServices.getCountriesAPI();
            let data = res.data;
            return data;
        }, 
        
        async getStatesDataAction(_, payload) {
            let res = await ProductServices.getStatesApi(payload);
            let data = res.data;
            return data;
        },

        async getCitiesDataAction(_, payload) {
            let res = await ProductServices.getCitiesApi(payload);
            let data = res.data;
            return data;
        },

        async addOrderAction({ commit }, payload) {
            let res = await ProductServices.addOrderApi(payload);
            let data = res.data;
            if(data.success){
                commit('Auth/userBalanceUpdateMutation', `${data.balance}`, { root: true });
            }
            return data;
        },

        async getPlacementTypesAction() {
            let res = await ProductServices.getPlacementTypesAPI();
            return res.data;
        },

        async addBrandMentionOrderAction({ commit }, payload) {
            let res = await ProductServices.addBrandMentionOrderApi(payload);
            let data = res.data;
            if(data.success){
                commit('Auth/userBalanceUpdateMutation', `${data.balance}`, { root: true });
            }
            return data;
        },

        async addBalanceAction({ commit }, payload) {
            let res = await ProductServices.addBalanceApi(payload);
            let data = res.data;
            if(data.success){
                commit('Auth/userBalanceUpdateMutation', `${data.balance}`, { root: true });
            }
            return data;
        },

        async getOrdersDataAction(_, payload) {
            let res = await ProductServices.getOrdersApi(payload);
            let data = res.data;
            return data;
        },

        async getTabsDetailDataAction() {
            let res = await ProductServices.getTabsDetailApi();
            let data = res.data;
            return data;
        },

        async applyCouponAction(_, payload) {
            let res = await ProductServices.applyCouponApi(payload);
            let data = res.data;
            return data;
        },

        async getExistingCardsDataAction (){
            let res = await ProductServices.getExistingCardsAPI();
            let data = res.data;
            return data;
        }, 
        async getDraftOrderAction (_, payload){
            let res = await ProductServices.getDraftOrderAPI(payload);
            let data = res.data;
            return data;
        },  

        async deleteDraftOrderAction (_, payload){
            let res = await ProductServices.deleteDraftOrderAPI(payload);
            let data = res.data;
            return data;
        }, 

        async approvedDraftOrderAction (_, payload){
            let res = await ProductServices.approvedDraftOrderAPI(payload);
            let data = res.data;
            return data;
        }, 

        async domainDataAction (_, payload){
            let res = await ProductServices.domainDataAPI(payload);
            let data = res.data;
            return data;
        }, 

        async getOrderPlanCountAction (){
            let res = await ProductServices.orderPlanCountDataAPI();
            let data = res.data;
            return data;
        }, 
        
        async getSelectedCardDataAction(_, payload) {
            let res = await ProductServices.selectedCardDetailApi(payload);
            let data = res.data;
            return data;
        },

        async getReferralCouponAction() {
            let res = await ProductServices.getReferralCouponApi();
            let data = res.data;
            return data;
        },
        async getInvoicePaymentAction(_, payload) {
            let res = await ProductServices.getInvoicePaymentApi(payload);
            let data = res.data;
            return data;
        },

        async validateInvoiceDraftOrdersAction(_, payload) {
            let res = await ProductServices.validateInvoiceDraftOrdersApi(payload);
            let data = res.data;
            return data;
        },

        async validateDraftCheckoutAction(_, payload) {
            let res = await ProductServices.validateDraftCheckoutApi(payload);
            let data = res.data;
            return data;
        },

        async validateDraftOrderAction(_, payload) {
            let res = await ProductServices.validateDraftOrderApi(payload);
            let data = res.data;
            return data;
        },

        async createDraftCheckoutSessionAction(_, payload) {
            let res = await ProductServices.createDraftCheckoutSessionApi(payload);
            let data = res.data;
            return data;
        },

        async getDraftCheckoutPreviewAction(_, payload) {
            let res = await ProductServices.getDraftCheckoutPreviewApi(payload);
            let data = res.data;
            return data;
        },

        async payDraftCheckoutAction(_, payload) {
            let res = await ProductServices.payDraftCheckoutApi(payload);
            let data = res.data;
            return data;
        },

        async getInvoicePaymentCountriesAction(_, payload) {
            let res = await ProductServices.getInvoicePaymentCountriesApi(payload);
            let data = res.data;
            return data;
        },

        async getInvoicePaymentStatesAction(_, payload) {
            let res = await ProductServices.getInvoicePaymentStatesApi(payload);
            let data = res.data;
            return data;
        },

        async getInvoiceExistingCardsAction(_, payload) {
            let res = await ProductServices.getInvoiceExistingCardsApi(payload);
            let data = res.data;
            return data;
        },

        async getInvoiceCardDetailAction(_, payload) {
            let res = await ProductServices.getInvoiceCardDetailApi(payload);
            let data = res.data;
            return data;
        },

        async invoiceStripeSavedPaymentMethodAction(_, payload) {
            let res = await ProductServices.invoiceStripeSavedPaymentMethodApi(payload);
            let data = res.data;
            return data;
        },

        async stripePaymentMethodAction(_, payload) {
            let res = await ProductServices.stripePaymentMethodApi(payload);
            let data = res.data;
            return data;
        },

        async invoiceStripePaymentMethodAction(_, payload) {
            let res = await ProductServices.invoiceStripePaymentMethodApi(payload);
            let data = res.data;
            return data;
        },

        async invoiceAchPaymentIntentAction(_, payload) {
            let res = await ProductServices.invoiceAchPaymentIntentApi(payload);
            let data = res.data;
            return data;
        },

        async orderAchPaymentIntentAction(_, payload) {
            let res = await ProductServices.orderAchPaymentIntentApi(payload);
            let data = res.data;
            return data;
        },

        async invoiceAchStartAction(_, payload) {
            let res = await ProductServices.invoiceAchStartApi(payload);
            let data = res.data;
            return data;
        },

        async invoicePayAction(_, payload) {
            let res = await ProductServices.invoicePayApi(payload);
            let data = res.data;
            return data;
        },

        async downloadInvoicePaymentAction(_, payload) {
            let res = await ProductServices.downloadInvoicePaymentApi(payload);
            return res.data;
        },

        async stripeSavePaymentMethodAction(_, payload) {
            let res = await ProductServices.stripeSavePaymentMethodApi(payload);
            let data = res.data;
            return data;
        },

        async getEditedOrderAction (_, payload){
            let res = await ProductServices.getEditedOrderAPI(payload);
            let data = res.data;
            return data;
        },

        async getEditOrderLinksAction (_, payload){
            let res = await ProductServices.getEditOrderLinksAPI(payload);
            let data = res.data;
            return data;
        },

        async addOrderBalanceAction (_, payload){
            let res = await ProductServices.addOrderBalanceAPI(payload);
            let data = res.data;
            return data;
        },

        async editOrderPaymentAction({ commit }, payload) {
            let res = await ProductServices.editOrderPaymentAPI(payload);
            let data = res.data;
            if(data.success){
                commit('Auth/userBalanceUpdateMutation', `${data.balance}`, { root: true });
            }
            return data;
        },

        async approveEditedOrderAction (_, payload){
            let res = await ProductServices.approveEditedOrderAPI(payload);
            let data = res.data;
            return data;
        },

        async updateOrderDataAction (_, payload){
            let res = await ProductServices.updateOrderDataAPI(payload);
            let data = res.data;
            return data;
        },

        async updateLinkDetailsDataAction (_, payload){
            let res = await ProductServices.updateLinkDetailsAPI(payload);
            let data = res.data;
            return data;
        },
    }
}